import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Button from 'shared/Button';
import Modal from 'shared/Modal';
import { MobileTabletOnly, DesktopUp } from 'shared/Responsive';

import SignInForm from '../components/SignInForm';
import SignUpForm from '../components/SignUpForm';

import CheckmarkGradient from 'images/ask/icons/check.svg';

import { withUser } from '../contexts/user';
import { withClinicalData } from '../contexts/clinicalData';

class CreateAccount extends Component {
  constructor(props) {
    super(props);

    this.state = {
      signUpModalOpen: false
    };
  }

  handleSignIn = (user) => {
    this.props.user.logIn(user);
  }

  handleSignUp = (user) => {
    this.props.user.logIn(user);
  }

  handleSignUpButtonClick = () => {
    this.setState({ signUpModalOpen: true });
  }

  handleModalClose = () => {
    this.setState({ signUpModalOpen: false });
  }

  componentDidMount() {
    this.classifyImageIfUser(this.props);
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.classifyImageIfUser(props);
  }

  classifyImageIfUser(props) {
    if (props.user.isLoggedIn) {
      props.clinicalData.classifyImage();
    }
  }

  render() {
    const { signUpModalOpen } = this.state;

    return (
      <div className="create-account-view container--split">
        <div className="container__top">
          <MobileTabletOnly>
            <img className="header-icon" src={CheckmarkGradient} />
          </MobileTabletOnly>

          <h1>
            Your results are ready.
            <DesktopUp>
              <img className="header-icon" src={CheckmarkGradient} />
            </DesktopUp>
          </h1>
        </div>

        <div className="container__left">
          <div className="content">
            <h2>
              Sign up to see your results
            </h2>
            <p>
              See your results for free by signing up for a Triage account.
            </p>

            <Button className="create-account-view__signup-button" onClick={this.handleSignUpButtonClick}>
              Sign up
            </Button>

            {signUpModalOpen && (
              <Modal
                className="sign-up-modal"
                headerText="Sign up"
                onModalClose={this.handleModalClose}
              >
                <SignUpForm onSignUp={this.handleSignUp} showSignInLink={false} onModalClosed={this.handleModalClose.bind(this)} />
              </Modal>
            )}
          </div>

          <span className="create-account__or">or</span>
        </div>

        <div className="container__right">
          <div className="content">
            <h2>Sign in</h2>

            <SignInForm showTitle={false} showSignUpLink={false} onSignIn={this.handleSignIn} />
          </div>
        </div>
      </div>
    );
  }
}

CreateAccount.defaultProps = {};

CreateAccount.propTypes = {
  user: PropTypes.object.isRequired,
  clinicalData: PropTypes.object.isRequired
};

export { CreateAccount };
export default withClinicalData(withUser(CreateAccount));
